import { V3Record } from 'data/helpers/V3Record.js'

export const Region = V3Record('region', {
  slug: null, // string
  name: null, // string
  description: null, // string
  cover: null, // file
  countryCode: null, // string
  zone: null, // string
  shortDescription: null, // string
  subtitle: null, // string
  radius: null, // int
  updatedAt: null, // datetime
  routesCount: null // int
})
